var _defs, _circle, _line, _line2, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MICROPHONE",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333e49;opacity:0.7;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-linecap:round;stroke-width:24.24px;}.cls-2{stroke-miterlimit:10;}.cls-3{stroke-linejoin:bevel;}.cls-4{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 455.61
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 410.81,
    y1: 649.61,
    x2: 582.97,
    y2: 649.61
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 496.89,
    y1: 649.61,
    x2: 496.89,
    y2: 580.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M610,419.12v64.66c0,14.81-.33,25.84-6.3,38.44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M383.8,419.12v64.66c0,53.41,43.72,97.1,97.1,97.1h32c15.45,0,27.06-.64,40-7.12"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M551,475.66V346.53a54.29,54.29,0,0,0-54.14-54.14h0a54.3,54.3,0,0,0-54.14,54.14v20.82"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M442.72,457.51v26.42a54.32,54.32,0,0,0,54.14,54.17h0a52.92,52.92,0,0,0,21.79-4.64Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M642.18,611.89h0a15.16,15.16,0,0,1-21.42,0l-178-178-84.9-84.91a15.14,15.14,0,0,1,0-21.42h0a15.16,15.16,0,0,1,21.42,0L442.72,391,549.28,497.56l42.56,42.57,50.34,50.34A15.14,15.14,0,0,1,642.18,611.89Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.ddb9af2acd8b4b54f89fb0cfbb953626.svg";
export { ForwardRef as ReactComponent };